module.exports = __webpack_public_path__ + "img/frame-1.f22e7a89.png";